import { useState } from "react";

import AddIcon from "@mui/icons-material/AddCircleRounded";
import { Box, Button, Stack, Typography } from "@mui/material";
import { getISOWeek, getISOWeekYear } from "date-fns";

import { AppointmentCreationDialog } from "@/common/components/appointments/appointment-creation/AppointmentCreationDialog";
import { PlanAttendanceDialog } from "@/common/components/appointments/plan-attendance/PlanAttendanceDialog";
import { AppointmentTargetCalculatorDialog } from "@/common/components/calculators/appointment-target-calculator-dialog/AppointmentTargetCalculatorDialog";
import { useCurrentUserContext } from "@/common/contexts/current-user-context/CurrentUserContext";
import { useTranslation } from "@/translations";

import { AppointmentsWeek } from "./components/appointments-week/AppointmentsWeek";

export function AppointmentsOverview() {
  const { t } = useTranslation();
  const { currentUser } = useCurrentUserContext();
  const [selectedCounselorId, setSelectedCounselorId] = useState<string | null>(currentUser.counselorId ?? "");
  const [currentStart, setCurrentStart] = useState<Date>(new Date());
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [isTargetCalculatorOpen, setIsTargetCalculatorOpen] = useState(false);
  const [showPlanAttendanceWeekDialog, setShowPlanAttendanceWeekDialog] = useState<boolean>();

  return (
    <Stack spacing={3} sx={{ height: "100%" }} pb={3}>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Typography variant="h1">
          {t("calendar.appointmentOverviewTitle", {
            week: getISOWeek(currentStart),
            year: getISOWeekYear(currentStart),
          })}
        </Typography>
        <Box display="flex" gap={1}>
          <Button variant="outlined" onClick={() => setIsTargetCalculatorOpen(true)}>
            {t("calculators.appointmentTargets.title")}
          </Button>
          <Button variant="outlined" onClick={() => setShowPlanAttendanceWeekDialog(true)}>
            {t("calendar.planAttendance.buttonLabel")}
          </Button>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => setIsCreateOpen(true)}>
            {t("calendar.createAppointment")}
          </Button>
        </Box>
      </Box>
      <AppointmentsWeek
        selectedCounselorId={selectedCounselorId}
        onCounselorChange={setSelectedCounselorId}
        onDateChange={(start) => setCurrentStart(start)}
        onAttendanceHeaderClick={() => setShowPlanAttendanceWeekDialog(true)}
      />
      {isCreateOpen && (
        <AppointmentCreationDialog initialCounselorId={selectedCounselorId} onClose={() => setIsCreateOpen(false)} />
      )}
      {isTargetCalculatorOpen && <AppointmentTargetCalculatorDialog onClose={() => setIsTargetCalculatorOpen(false)} />}
      {showPlanAttendanceWeekDialog && (
        <PlanAttendanceDialog initialWeekStart={currentStart} onClose={() => setShowPlanAttendanceWeekDialog(false)} />
      )}
    </Stack>
  );
}
